import type { ComponentPropsWithoutRef } from 'react'
import { useTransition, animated } from 'react-spring'
import type { SpringConfig } from 'react-spring'

type SlideDirection = 'up' | 'down' | 'left' | 'right'

const DIRECTIONS: Record<SlideDirection, string> = {
  up: 'translate3d(0,-120%,0)',
  down: 'translate3d(0,120%,0)',
  left: 'translate3d(-120%,0,0)',
  right: 'translate3d(120%,0,0)'
}

const DIRECTIONS_ENTER: Record<SlideDirection, string> = {
  up: 'translate3d(0,0%,0)',
  down: 'translate3d(0,0%,0)',
  left: 'translate3d(0%,0,0)',
  right: 'translate3d(0%,0,0)'
}

type SlideProps = ComponentPropsWithoutRef<'div'> & {
  show: boolean
  direction?: SlideDirection
  springConfig?: SpringConfig
}

export const Slide = ({
  direction = 'up',
  show,
  children,
  className,
  springConfig,
  style = {},
  ...rest
}: SlideProps) => {
  const transitions = useTransition(show, {
    from: { transform: DIRECTIONS[direction] },
    enter: { transform: DIRECTIONS_ENTER[direction] },
    leave: { transform: DIRECTIONS[direction] },
    initial: null
  })
  return transitions(
    (props, show) =>
      show && (
        <animated.div className={className} style={{ ...style, ...props }} {...rest}>
          {children}
        </animated.div>
      )
  )
}

export default Slide
